module.exports = __webpack_public_path__ + "static/media/logo(ua).30b0b35c.svg";